import React from 'react';
import { node } from 'prop-types';
import Tooltip from 'rc-tooltip';

import useStyles from 'hooks/useStyles';

import styles from './BaseTooltip.scss';

function BaseTooltip({ children, ...props }) {
  useStyles(styles);

  return (
    <Tooltip
      placement="bottomLeft"
      trigger="hover"
      mouseEnterDelay={1}
      {...props}
    >
      {children}
    </Tooltip>
  );
}

BaseTooltip.propTypes = {
  children: node.isRequired,
};

export default BaseTooltip;
